<template>
  <el-row>
    <el-col>
      <Filters
        class="mb-3"
        :resource="$sdk.account_location"
        :filters.sync="filters"
        @apply="$refs.table.loadTable()"
        @ready="$refs.table.loadTable()"
      />

      <el-card shadow="never">
        <LocationsTable
          ref="table"
          :account-id="accountId"
          :filters="filters"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import LocationsTable from '@/components/Application/CustomerService/Accounts/Account/Locations/LocationsTable'
import Filters from '@/components/Filters/Complex'

export default {
  components: {
    LocationsTable,
    Filters
  },
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      actions: [],
      breadcrumb: {
        name: 'Locations',
        route: { name: 'manage-accounts-account-locations', params: { accountId: this.$route.params.accountId } }
      },
      filters: []
    }
  },
  mounted () {
    this.actions = this.$refs.table.actions
  }
}
</script>
